import {
  ApolloClient,
  ApolloLink,
  from,
  HttpLink,
  InMemoryCache,
} from "@apollo/client";
// import { refreshToken } from "./axios";
import { refreshToken } from "./public/repositories/authenticationRepository";
import { onError } from "@apollo/client/link/error";
import { API_URL, AUTH_TOKEN, MANAGMENT_API_URL } from "./constants";

export const clearAuthLocalStorage = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user");
};
// TODO @slavco: Create a JWTUtils
// TODO @slavco: Check if the token isExpired
// TODO @slavco: isExpired: true => Request a new one

const httpLink = new HttpLink({ uri: API_URL });
const managmentHttpLink = new HttpLink({ uri: MANAGMENT_API_URL });

const authMiddleware = new ApolloLink((operation, forward) => {
  // TODO: Decode the JWT Token
  // TODO: isExpired?
  // TODO: If true refresh the token

  // add the authorization to the headers
  const token = localStorage.getItem("token");
  if (token) {
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        authorization: `Bearer ${token}`,
      },
    }));
  }
  return forward(operation);
});

const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      for (let err of graphQLErrors) {
        switch (err.extensions!.code) {
          case "invalid-jwt":
            clearAuthLocalStorage();
            operation.setContext({
              headers: {},
            });
            return forward(operation);
        }
      }
    }
  }
);

export async function updateToken() {
  const refresh_token = localStorage.getItem("refresh_token");
  const data = await refreshToken({ refresh_token });
  localStorage.setItem("token", data.jwt_token);
  localStorage.setItem("refresh_token", data.refresh_token);

  return data.jwt_token;
}

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: from([authMiddleware, errorLink, httpLink]),
});
export const managmentClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: from([authMiddleware, errorLink, managmentHttpLink]),
});
// A client for non-authenticated requests
export const publicClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: from([httpLink]),
});

export const resetApolloStore = async () => {
  await client.resetStore();
  await publicClient.resetStore();
};

export async function getRealTokenBasedOnRefresh(refresh_token) {
  const data = await refreshToken({ refresh_token });
  return data.jwt_token;
}
